export type EjendomSummariskMatrikelRef = {
  elav: string;
  matnr: string;
};

export type EjendomSummariskJordstykkeRef = {
  status?: string | null;
  matrikelnummer?: string | null;
  samletFastEjendomLokalId?: string | null;
  jordstykkeLiggerIEjerlav?: {
    ejerlavskode?: string | number | null;
  } | null;
};

/**
 * Kun tingbog attest (`getEjendomSummarisk`): matrikelnummerets taldel skal være 4 cifre (fx 0184b, 0001ø).
 */
export function normalizeMatrikelnummerForEjendomSummarisk(
  matrikelnummer: string,
): string {
  const trimmed = matrikelnummer.trim();
  const digits = trimmed.replace(/\D/g, "");
  const suffix = trimmed.replace(/\d/g, "").trim();
  if (!digits) {
    return trimmed;
  }
  return `${digits.padStart(4, "0")}${suffix}`;
}

function readJordstykkeMatrikel(node: EjendomSummariskJordstykkeRef): string | undefined {
  const mat = node.matrikelnummer?.toString().trim();
  return mat || undefined;
}

function readJordstykkeEjerlav(node: EjendomSummariskJordstykkeRef): string | undefined {
  const elav = node.jordstykkeLiggerIEjerlav?.ejerlavskode?.toString().replace(/\s+/g, "").trim();
  return elav || undefined;
}

/** Current cadastral parcels only — historical / unfinished rows make tingbogen return ejendomIkkeFundet. */
export function filterCurrentJordstykkerForEjendomSummarisk<T extends EjendomSummariskJordstykkeRef>(
  nodes: T[] | undefined | null,
  sfeLokalId?: string | null,
): T[] {
  const list = nodes ?? [];
  const matchingSfe = sfeLokalId
    ? list.filter((node) => node.status === "Gældende" && node.samletFastEjendomLokalId === sfeLokalId)
    : [];
  const pool = matchingSfe.length > 0
    ? matchingSfe
    : list.filter((node) => node.status === "Gældende");
  return pool.filter((node) => readJordstykkeMatrikel(node) && readJordstykkeEjerlav(node));
}

export function toEjendomSummariskMatrikelListe(
  nodes: EjendomSummariskJordstykkeRef[] | undefined | null,
  sfeLokalId?: string | null,
): EjendomSummariskMatrikelRef[] {
  return filterCurrentJordstykkerForEjendomSummarisk(nodes, sfeLokalId).flatMap((node) => {
    const matnr = readJordstykkeMatrikel(node);
    const elav = readJordstykkeEjerlav(node);
    return matnr && elav ? [{ elav, matnr }] : [];
  });
}
